import './style/ui.sass';

import React from 'react';
import 'jquery';
import Account from '../account/account';
import API, {api_level} from '../shared/api';
import {createComet} from '../shared/api/comet';
import {setup_back_button} from '../utils/back-button';
import {BaseUI} from './base-ui';
import {UniversalUI} from './universal-ui';

import '../../mui/mui';
import '../../mui/dialog';

import {initSentry, with_sentry} from '../shared/sentry';
import {UserInfo} from '../shared/api/auth/base';
import {UIThemeProvider} from '../theme/styles/provider';
import {HashRouter} from 'react-router-dom';

import 'setimmediate';

// Webpack will load dynamically imported modules  from this path
// window.ZONT_SCRIPT_BASE is specified by Python in ui.html
__webpack_public_path__ = window.ZONT_SCRIPT_BASE;

initSentry();
with_sentry((Sentry) => {
    Sentry.configureScope((scope) => {
        const {id, username, email, is_guest, is_demo, is_staff} = PRELOAD.account;
        scope.setUser({id, username, email, is_guest, is_demo, is_staff});
    });
});

// if saved prev_server_time is equal to PRELOAD.server_time, then we are probably
// restored from browser's cache
const is_loaded_from_cache = () =>
    localStorage.getItem('prev_server_time') >= window.PRELOAD.server_time.toString();

const load_actual_inflate_data = async function () {
    if (window.PRELOAD != null && !is_loaded_from_cache()) {
        try {
            localStorage.setItem('prev_server_time', window.PRELOAD.server_time);
        } catch {}
        return;
    }

    console.log("seems we're started from cached html, invoking inflate_ui");

    const accountInfo = window.PRELOAD?.account;
    const userInfo =
        accountInfo != null ? new UserInfo(accountInfo.id, accountInfo.is_guest) : null;
    const api = new API(userInfo);
    try {
        window.PRELOAD = await api.call_v2({
            method: 'inflate_ui',
            data: {api_level, load_io: true},
        });
    } catch (err) {
        console.error(err);
        location.reload(false);
    }
};

const disable_all_scrollbars = function () {
    const s = document.createElement('style');
    s.innerText = '*::-webkit-scrollbar { display: none !important; }';
    document.documentElement.appendChild(s);
};

const HotUI = ({ui}) => {
    return (
        <HashRouter>
            <UIThemeProvider>
                <UniversalUI ui={ui} />
            </UIThemeProvider>
        </HashRouter>
    );
};

function TS() {
    return new Date().toLocaleString('sv', {timeZone: 'UTC'}) + 'Z';
}

function hookLogType(logType) {
    const original = console[logType].bind(console);
    return function () {
        console.everything.push({
            type: logType,
            timeStamp: TS(),
            value: Array.from(arguments),
        });
        original.apply(console, arguments);
    };
}

if (console.everything === undefined) {
    console.everything = [];

    window.onerror = function (error, url, line) {
        console.everything.push({
            type: 'exception',
            timeStamp: TS(),
            value: {error, url, line},
        });
        return false;
    };
    window.onunhandledrejection = function (e) {
        console.everything.push({
            type: 'promiseRejection',
            timeStamp: TS(),
            value: e.reason,
        });
    };

    ['log', 'error', 'warn', 'debug'].forEach((logType) => {
        console[logType] = hookLogType(logType);
    });
}

window.logs = console.everything;

document.addEventListener('DOMContentLoaded', async function () {
    setup_back_button();

    await load_actual_inflate_data();

    const real_account = window.PRELOAD.account;
    const account = new Account(real_account);
    //не класс, нужен для отображения нового UI
    const api = new API(new UserInfo(real_account.id, real_account.is_guest));
    const comet = createComet(api);

    if (location.search.indexOf('noscrollbars') !== -1) {
        disable_all_scrollbars();
    }
    window._ui = new BaseUI(account, api, comet, (ui) => <HotUI ui={ui} />);

    window._ui.bind('logout', () => (location.href = ZONT_URL.logout));
});
